import "../base";

const categories = document.querySelectorAll(".category");
const select = document.getElementById("categories");

select.addEventListener("change", e => {
  const category = e.target.value;
  // if (category >= 0) {
  categories.forEach(
    el => {
      if (category < 0 || el.dataset.category === category) {
        el.dataset.showing = "1";
      } else {
        el.dataset.showing = "0";
      }
    }
    // el.dataset.category === category
    //   ? (el.dataset.showing = "1")
    //   : (el.dataset.showing = "0")
  );
  // } else {
  //   categories.forEach(el => (el.dataset.showing = "1"));
  // }
});
